module.exports = __webpack_public_path__ + "static/media/logo.c4cb65df.svg";